import $ from 'jquery'
import _ from 'lodash'
import I18n from 'i18n-js'

const spinner = `<div class="sf-text sf-align-c sf-pad-v-3">
<span class="sf-spinner sf-inline-block"></span>
</div>`

let selectedRtIds = []
let selectedRtIdsElement

const fetchAutoAddedPartial = ($el, $dom) => {
  const renderTarget = $el.data('render-target')
  const linkTarget = $el.data('link-target')
  const linkTemplate = $el.data('link-template')
  const workflowId = $el.data('workflow-id')
  const reconciliationReportId = $el.val()
  const reconciliationReportName = $el.find('option:selected').text()

  if (reconciliationReportId) {
    $(renderTarget).html(spinner)

    setLink(
      linkTarget,
      linkTemplate.replace('--ID--', reconciliationReportId),
      reconciliationReportName
    )

    const params = {
      firm_id: Silverfin.currentFirmId,
      reconciliation_report_id: reconciliationReportId,
      workflow_id: workflowId,
      selected_rt_ids: selectedRtIds,
    }

    const done = (data) => {
      $(renderTarget).html(data)

      initSelectAllCheckbox($dom)
    }

    if (params.firm_id) {
      $.get(
        Silverfin.Routes.auto_add_rt_form_firm_workflows_path(params),
        done,
        'html'
      )
    } else {
      $.get(
        Silverfin.Routes.auto_add_rt_form_partners_template_collection_accounting_workflows_path(
          params
        ),
        done,
        'html'
      )
    }
  } else {
    $(renderTarget).html('')
    setLink(linkTarget, '')
  }
}

const setLink = (target, content, name) => {
  const $target = $(target)
  $target.html(content)

  const node = $target.find('a')
  node.text(node.text().replace('--NAME--', name))
}

const initSelectAllCheckbox = ($dom) => {
  const $rtCheckboxes = $dom.find(
    "[data-behaviour='workflow-rt-checkbox-item']"
  )
  const $selectAllButton = $dom.find(
    "[data-behaviour='workflow-rts-select-all']"
  )

  const notChecked = $.map($rtCheckboxes, (checkbox) =>
    $(checkbox).prop('checked')
  ).filter((v) => v === false)

  if (notChecked.length === 0) {
    $selectAllButton.prop('checked', true)
  }

  $rtCheckboxes.change(function () {
    const rtIdName = JSON.parse(this.dataset['unchecked'] || '{}')
    const rtId = String(this.value)
    const $submit = $dom.find("[type='submit']")

    if (this.checked) {
      selectedRtIds.push(rtId)

      if (this.dataset['unchecked']) {
        $submit.data(
          'rts-added',
          ($submit.data('rts-added') || []).concat(rtIdName)
        )
      }
    } else {
      selectedRtIds = selectedRtIds.filter((id) => id !== rtId)

      $submit.data(
        'rts-added',
        _.reject($submit.data('rts-added') || [], ['id', rtIdName.id])
      )
    }
    // hidden element storing the list of selected RT IDs, to be submitted with the form,
    // in order to "restore" the state of the ajax-rendered RT form
    if (selectedRtIdsElement) {
      selectedRtIdsElement.value = selectedRtIds
    }

    let confirmText = null
    if ($submit.data('rts-added') && $submit.data('rts-added').length > 0) {
      confirmText = I18n.t(
        'firm_workflows.js.newly_auto_added_reconciliations_html',
        { reconciliations: _.map($submit.data('rts-added'), 'name').join(', ') }
      )
    }
    $submit.attr('data-confirm', confirmText)
  })

  $selectAllButton.each(function () {
    const $this = $(this)
    $this.on('click', (e) => {
      $($rtCheckboxes).prop('checked', $(e.target).prop('checked')).change()
    })
  })
}

onDomLoad(function ($dom) {
  selectedRtIdsElement = document.querySelector('#selected-partner-rts')

  if (selectedRtIdsElement) {
    selectedRtIds = JSON.parse(selectedRtIdsElement.value).map((i) => String(i))
  }

  $dom
    .find(
      "[data-behaviour='accounting-workflow-reconciliation-report-dropdown']"
    )
    .each(function () {
      const $this = $(this)

      fetchAutoAddedPartial($this, $dom)

      $this.on('change', (e) => {
        fetchAutoAddedPartial($(e.target), $dom)
      })
    })
})
